import React, { useState, useEffect } from 'react';
import axios from 'axios';
import config from '../config';
import '../styles/PrivacyPolicy.css';

function PrivacyPolicy({ onBack }) {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${config.apiUrl}/api/legal/privacy-policy`);
      setContent(response.data);
      setError(null);
    } catch (err) {
      console.error('Error fetching privacy policy:', err);
      setError('Failed to load privacy policy. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="privacy-policy-container">
        <div className="privacy-policy-header">
          <button className="back-button" onClick={onBack}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M19 12H5"/>
              <path d="M12 19l-7-7 7-7"/>
            </svg>
          </button>
          <h2>Privacy Policy</h2>
        </div>
        <div className="privacy-policy-content">
          <div className="loading-state">
            <div className="loading-spinner"></div>
            <p>Loading privacy policy...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="privacy-policy-container">
        <div className="privacy-policy-header">
          <button className="back-button" onClick={onBack}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M19 12H5"/>
              <path d="M12 19l-7-7 7-7"/>
            </svg>
          </button>
          <h2>Privacy Policy</h2>
        </div>
        <div className="privacy-policy-content">
          <div className="error-state">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12" y2="12"/>
              <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
            <p>{error}</p>
            <button onClick={fetchContent} className="retry-button">Try Again</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="privacy-policy-container">
      <div className="privacy-policy-header">
        <button className="back-button" onClick={onBack}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M19 12H5"/>
            <path d="M12 19l-7-7 7-7"/>
          </svg>
        </button>
        <h2>{content?.title || 'Privacy Policy'}</h2>
      </div>

      <div className="privacy-policy-content">
        <div className="policy-intro">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="policy-icon">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
          </svg>
          {content?.updatedAt && (
            <p className="last-updated">
              Last Updated: {new Date(content.updatedAt).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
            </p>
          )}
          {content?.version && (
            <p className="version-info">Version {content.version}</p>
          )}
        </div>

        <div 
          className="dynamic-content"
          dangerouslySetInnerHTML={{ __html: content?.content || '' }}
        />
      </div>
    </div>
  );
}

export default PrivacyPolicy;
